/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Plan_Gate_Starting_AtInputs */



/**
* | output |
* | --- |
* | "Starting at €{price} / user / month" |
*
* @param {Plan_Gate_Starting_AtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_starting_at = /** @type {((inputs: Plan_Gate_Starting_AtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Starting_AtInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ab €${i?.price} / Nutzer / Monat`)
	return /** @type {LocalizedString} */ (`Starting at €${i?.price} / user / month`)
});